import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { filter, map, Observable } from 'rxjs';
import { DkDxDataCtlTableComponent } from '../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { ColumnModel } from '../../models/dx-data-table.model';
import { DlistDto } from '../../models/ortak.dtos';
import { OrtakService } from '../../services/ortak.service';
import { LogFormIslemService } from './log-form-islem.service';

export interface LogFormIslemViewModel {
  gridCtl: DlistDto;
  columnList: ColumnModel[];
}

@Component({
  selector: 'dk-log-form-islem',
  standalone: true,
  imports: [CommonModule, DkDxDataCtlTableComponent],
  templateUrl: './log-form-islem.component.html',
  styleUrls: ['./log-form-islem.component.scss'],
})
export class LogFormIslemComponent implements OnInit {
  @Input() public formCode: string;

  public dataSource: any;

  readonly viewModel$: Observable<LogFormIslemViewModel> = this.logFormIslemService.gridControlsLogList$.pipe(
    filter((gridCtl): gridCtl is DlistDto => !!gridCtl),
    map(gridCtl => ({
      gridCtl,
      columnList: this.ortakService.setRecursiveFieldData([gridCtl], false),
    }))
  );

  constructor(private logFormIslemService: LogFormIslemService, private ortakService: OrtakService) {
    this.logFormIslemService.getFormIslemLogDlist('vLogFormIslem');
  }

  ngOnInit() {
    if (this.formCode) {
      this.dataSource = this.logFormIslemService.getFormIslemLogData(this.formCode);
    }
  }
}
